module.exports = __webpack_public_path__ + "img/ar_pdf.826aa21b.png";